export default {"src":"/_next/static/media/Category_20.b7118ecb.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};